module.exports = __webpack_public_path__ + "img/status_success_black.d82e6a0d.png";